import { CoreApi } from '@framework/utils/core-api';
import { API_ENDPOINTS } from '@framework/utils/endpoints';

export type CustomerType = {
  id: string;
  [key: string]: unknown;
};
export type ContactType = {
  name: string;
  email: string;
  subject: string;
  description: string;
};
export type UpdateIco = {
  ico: string,
  id: number
}

export type PolicyAccept = {
  answer: string,
}

class Customer extends CoreApi {
  constructor(_base_path: string) {
    super(_base_path);
  }
  updateCustomer(input: CustomerType) {
    return this.http
      .put(this._base_path + '/' + input.id, input)
      .then((res) => res.data);
  }
  contact(input: ContactType) {
    return this.http.post(API_ENDPOINTS.CONTACT, input).then((res) => res.data);
  }
  deleteAddress({ id }: { id: string }) {
    return this.http
      .delete(`${API_ENDPOINTS.ADDRESS}/${id}`)
      .then((res) => res.data);
  }
  updateAddress(input: any[]) {
    return this.http
      .post(`${API_ENDPOINTS.UPDATE_MULTIPLE_ADDRESS}`, input)
      .then((res) => res.data);
  }

  verifyEmail(email: string) {
    return this.http
      .get(`${API_ENDPOINTS.VERIFY_EMAIL}`, { params: { email } })
      .then((res) => res.data)
  }

  updateIco(input: UpdateIco) {
    return this.http
      .put(this._base_path + '/' + input.id + '/update-ico', {ico: input.ico})
      .then((res) => res.data);
  }

  accept(input: PolicyAccept) {
    return this.http
      .post(`${API_ENDPOINTS.POLICY}/accept`, {answer: input.answer})
      .then((res) => res.data);
  }
  findPolicyByUser() {
    return this.http.get(`${API_ENDPOINTS.POLICY_BY_USER}`)
      .then((res) => res.data);
  }
}

export const CustomerService = new Customer(API_ENDPOINTS.CUSTOMERS);
